function Search() {
  return (
    <div>
      <h1>検索</h1>
    </div>
  );
}
export default Search;
